/*
 * TrueVault Polaris privacy controls.
 * 1. Hides Polaris's floating "How can we use your data?" button (it covers the
 *    mobile sticky Add to Cart and the hair quiz widget). The first-visit banner
 *    is untouched.
 * 2. Footer "Your Privacy Choices" links (and any a[data-privacy-choices],
 *    e.g. on Shogun pages) open the Polaris consent popup when
 *    Polaris's button exists; otherwise the link follows its href.
 */
(function () {
  var HOST_ID = 'polaris-css-lockdown-container';
  var STYLE_ID = 'viori-hide-polaris-fab';
  var FAB_CSS = '[class*="polaris-preferences-fab"]{display:none!important}';
  var WAIT_MS = 20000;

  function injectStyle(root) {
    if (root.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = FAB_CSS;
    root.appendChild(style);
  }

  function watchShadowRoot(root) {
    injectStyle(root);
    // Polaris re-renders its shadow content; put the style back if it is wiped.
    new MutationObserver(function () {
      injectStyle(root);
    }).observe(root, { childList: true });
  }

  function tryAttach() {
    var host = document.getElementById(HOST_ID);
    if (host && host.shadowRoot) {
      watchShadowRoot(host.shadowRoot);
      return true;
    }
    return false;
  }

  function hideFab() {
    if (tryAttach()) return;
    var observer = new MutationObserver(function () {
      if (tryAttach()) {
        observer.disconnect();
        clearInterval(poll);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    // attachShadow() fires no DOM mutation, so also poll in case the host
    // element appears before its shadow root does.
    var poll = setInterval(function () {
      if (tryAttach()) {
        observer.disconnect();
        clearInterval(poll);
      }
    }, 250);
    setTimeout(function () {
      observer.disconnect();
      clearInterval(poll);
    }, WAIT_MS);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a');
    if (!link) return;
    var isFooterLink = link.closest('.shopify-section-group-footer-group') &&
      link.textContent.trim().toLowerCase() === 'your privacy choices';
    if (!isFooterLink && !link.hasAttribute('data-privacy-choices')) return;
    // polaris.openConsentModal() is a no-op while TrueVault's consent manager
    // is disabled, so open the popup by clicking Polaris's own (hidden) button.
    var host = document.getElementById(HOST_ID);
    var fab = host && host.shadowRoot && host.shadowRoot.querySelector('[class*="polaris-preferences-fab"]');
    if (!fab) return;
    event.preventDefault();
    fab.click();
  });

  if (document.body) {
    hideFab();
  } else {
    document.addEventListener('DOMContentLoaded', hideFab);
  }
})();
